import { toastr } from "react-redux-toastr";
import Api from "../../utils/config/api";
import {
  SET_LOYALTY_TYPE,
  SET_CASHBACK_TYPE,
  SET_PREV_CASHBACK_TYPE,
  TOGGLE_BOTTOM_SHEET,

  // settings
  GET_BANNERS,
  SET_ITEMS_MENU,
  UPDATE_BONUS_DETAILS,
  SET_STORES_EXCLUDE_ITEMS,
  SET_STORES_CASHBACK_PERCENTAGE,
  SET_STORES_MULTIPLE_BILL_ALERT,
  SET_ACTIVE_STEP_FOR_FRD_NOTIFY,
  SET_ADVANCED_CASHBACK_SEED_DATA,
  SET_STORES_EXCLUDE_PAYMENT_TYPES,

  // loyalty data
  UPDATE_PREVIEW_DETAILS,
  SET_LOYALTY_DATA,
  RESET_LOYALTY,

  // insights
  GET_LOYALTY_INSIGHTS,
  GET_LOYALTY_PERF_INSIGHTS,
  GET_LOYALTY_ACTIVITY,
  GET_LOYALTY_TIER_INSIGHTS,
  GET_LOYALTY_SCOREBOARD,
  GET_LOYALTY_CUSTOMERS,
} from "../types";

export const setLoyaltyTypeAction = (data) => (dispatch) => {
  dispatch({
    type: SET_LOYALTY_TYPE,
    payload: data,
  });
};

export const setCashbackTypeAction = (data) => (dispatch) => {
  dispatch({
    type: SET_CASHBACK_TYPE,
    payload: data,
  });
};

export const setPrevCashbackTypeAction = (data) => (dispatch) => {
  dispatch({
    type: SET_PREV_CASHBACK_TYPE,
    payload: data,
  });
};

export const updatePrevDetActions = (data) => (dispatch) => {
  dispatch({
    type: UPDATE_PREVIEW_DETAILS,
    payload: data,
  });
};

export const updateBnsDetActions = (data) => (dispatch) => {
  dispatch({
    type: UPDATE_BONUS_DETAILS,
    payload: data,
  });
};

export const toggleBottomSheet = (status) => (dispatch) => {
  dispatch({
    type: TOGGLE_BOTTOM_SHEET,
    payload: status,
  });
};

export const createLoyalty = (data, storeId, isCache) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.put(`/v1/loyalty/${storeId}${isCache ? "?cache=true" : ""}`, data)
      .then((res) => {
        dispatch({
          type: SET_LOYALTY_DATA,
          payload: res.data.payload,
        });
        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const getLoyalty = (store_id, isCache) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/loyalty/${store_id}${isCache ? "?cache=true" : ""}`)
      .then((res) => {
        const { payload } = res.data;
        dispatch({
          type: SET_LOYALTY_DATA,
          payload: payload,
        });

        return resolve(payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

// export const setRewardAsInactive = (data, storeId, rewardId) => () => {
//   return new Promise((resolve, reject) => {
//     Api.patch(`/v1/loyalty/${storeId}/rewards/${rewardId}/status`, data)
//       .then(() => resolve(true))
//       .catch((err) => {
//         err?.response?.status !== 401 &&
//           toastr.error(
//             "Error",
//             err?.response?.data?.message || "Something went wrong!"
//           );
//         return reject(err);
//       });
//   });
// };

// export const deleteAdvCashbackTier = (storeId, tierId) => () => {
//   return new Promise((resolve, reject) => {
//     Api.delete(`/v1/loyalty/${storeId}/tiers/${tierId}`)
//       .then(() => resolve(true))
//       .catch((err) => {
//         err?.response?.status !== 401 &&
//           toastr.error(
//             "Error",
//             err?.response?.data?.message || "Something went wrong!"
//           );
//         return reject(err);
//       });
//   });
// };

export const updateAdvCashbackTier = (storeId, data, isCache) => () => {
  return new Promise((resolve, reject) => {
    Api.put(`/v1/loyalty/${storeId}/tiers${isCache ? "?cache=true" : ""}`, data)
      .then((res) => resolve(res?.data?.payload))
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const updateAllRewards = (storeId, data, isCache) => () => {
  return new Promise((resolve, reject) => {
    Api.put(
      `/v1/loyalty/${storeId}/rewards${isCache ? "?cache=true" : ""}`,
      data
    )
      .then((res) => resolve(res.data.payload))
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const updateChannel = (data, storeId, channelId) => () => {
  return new Promise((resolve, reject) => {
    Api.patch(`/v1/loyalty/${storeId}/channels/${channelId}`, data)
      .then(() => {
        return resolve(true);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          err?.response?.data?.data?.map((errObj) =>
            toastr.error("Validation Error", errObj.message)
          );
          return reject(err?.response?.data?.data);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const sendTestMsgCall = (data, storeId) => () => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/loyalty/${storeId}/test?cache=true`, data)
      .then(() => {
        toastr.success("Successfully sent test message");
        return resolve(true);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const setActiveStepForFraudNotification = (step) => (dispatch) => {
  dispatch({
    payload: step,
    type: SET_ACTIVE_STEP_FOR_FRD_NOTIFY,
  });
};

export const getStoresForMultipleBillAlert = (groupId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/loyalty/multiple-bill-alerts/store-wise-settings/${groupId}`)
      .then((res) => {
        dispatch({
          payload: res?.data?.payload,
          type: SET_STORES_MULTIPLE_BILL_ALERT,
        });
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const updateStoresForMultipleBillAlert = (groupId, data) => {
  return new Promise((resolve, reject) => {
    Api.put(
      `/v1/loyalty/multiple-bill-alerts/store-wise-settings/${groupId}`,
      data
    )
      .then((res) => resolve(res?.data?.payload))
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const getStoresForExcludingItems = (groupId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/loyalty/exclude-items/store-wise-settings/${groupId}`)
      .then((res) => {
        dispatch({
          payload: res?.data?.payload,
          type: SET_STORES_EXCLUDE_ITEMS,
        });
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const updateStoresForExcludingItems = (groupId, data) => {
  return new Promise((resolve, reject) => {
    Api.put(`/v1/loyalty/exclude-items/store-wise-settings/${groupId}`, data)
      .then((res) => resolve(res?.data?.payload))
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message ||
              "Failed to update 'exclude items' for other stores."
          );
        return reject(err);
      });
  });
};

export const getStoresForExcludingPaymentTypes = (groupId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/loyalty/exclude-payment-types/store-wise-settings/${groupId}`)
      .then((res) => {
        dispatch({
          payload: res?.data?.payload,
          type: SET_STORES_EXCLUDE_PAYMENT_TYPES,
        });
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const updateStoresForExcludingPaymentTypes = (groupId, data) => {
  return new Promise((resolve, reject) => {
    Api.put(
      `/v1/loyalty/exclude-payment-types/store-wise-settings/${groupId}`,
      data
    )
      .then((res) => resolve(res?.data?.payload))
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message ||
              "Failed to update 'exclude payment types' for other stores."
          );
        return reject(err);
      });
  });
};

export const getStoresForCashbackPercentage = (groupId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/loyalty/cashback-percentage/store-wise-settings/${groupId}`)
      .then((res) => {
        dispatch({
          payload: res?.data?.payload,
          type: SET_STORES_CASHBACK_PERCENTAGE,
        });
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const updateStoresForCashbackPercentage = (groupId, data) => {
  return new Promise((resolve, reject) => {
    Api.put(
      `/v1/loyalty/cashback-percentage/store-wise-settings/${groupId}`,
      data
    )
      .then((res) => resolve(res?.data?.payload))
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message ||
              "Failed to update 'cashback percentage' for other stores."
          );
        return reject(err);
      });
  });
};

export const getLoyaltyInsights = (entityId, isAllStores) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/${isAllStores ? "groups/" : ""}insights/loyalty/${entityId}`)
      .then((res) => {
        dispatch({
          type: GET_LOYALTY_INSIGHTS,
          payload: res?.data?.payload,
        });
        return resolve(true);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const getLoyaltyPerfInsights =
  (
    storeId,
    period,
    start,
    end,
    isAllStores,
    groupId,
    isExport,
    isCompareStore
  ) =>
  (dispatch) => {
    const url = isAllStores
      ? `/v1/groups/loyalty/performance/${groupId}${
          period && `?period=${period}`
        }${(start && `&start=${start}`) || ""}${(end && `&end=${end}`) || ""}${
          isExport ? "&attachment=true" : ""
        }${isCompareStore ? "&compare_stores=true" : ""}`
      : `/v1/insights/loyalty/performance/${storeId}${
          period && `?period=${period}`
        }${(start && `&start=${start}`) || ""}${(end && `&end=${end}`) || ""}`;
    return new Promise((resolve, reject) => {
      Api.get(url)
        .then((res) => {
          if (isAllStores && isExport) {
            return resolve(res);
          } else {
            if (!isCompareStore)
              dispatch({
                type: GET_LOYALTY_PERF_INSIGHTS,
                payload: res?.data?.payload,
              });
            return resolve(res?.data?.payload);
          }
        })
        .catch((err) => {
          err?.response?.status !== 401 &&
            toastr.error(
              "Error",
              err?.response?.data?.message || "Something went wrong!"
            );
          return reject(err);
        });
    });
  };

export const getLoyaltyTierInsights = (storeId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/insights/loyalty-tier/insights/${storeId}`)
      .then((res) => {
        dispatch({
          type: GET_LOYALTY_TIER_INSIGHTS,
          payload: res?.data?.payload,
        });
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};
export const getTotalUniqueCustomerWhoRedeemed = (
  entityId,
  period,
  start,
  end
) => {
  const url = `/v1/insights/loyalty/performance/customer-count/${entityId}${
    period && `?period=${period}`
  }${(start && `&start=${start}`) || ""}${(end && `&end=${end}`) || ""}`;

  return new Promise((resolve, reject) => {
    Api.get(url)
      .then((res) => resolve(res?.data?.payload))
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const getScoreBoardRewards =
  (storeId, period, page, start, end) => (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.get(
        `/v1/insights/loyalty/rewards/scoreboard?storeId=${storeId}${
          (period && `&period=${period}`) || ""
        }${(page && `&page=${page}`) || "1"}${
          (start && `&start=${start}`) || ""
        }${(end && `&end=${end}`) || ""}`
      )
        .then((res) => {
          dispatch({
            type: GET_LOYALTY_SCOREBOARD,
            payload: res?.data?.payload,
          });
          return resolve(true);
        })
        .catch((err) => {
          err?.response?.status !== 401 &&
            toastr.error(
              "Error",
              err?.response?.data?.message || "Something went wrong!"
            );
          return reject(err);
        });
    });
  };

export const getLoyaltyCustomers =
  (storeId, period, page, start, end, search, isAttachment) => (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.get(
        `/v1/insights/loyalty/top/redeem/customers?storeId=${storeId}${
          (period && `&period=${period}`) || ""
        }${(page && `&page=${page}`) || "1"}${
          (start && `&start=${start}`) || ""
        }${(end && `&end=${end}`) || ""}${
          (search && `&search=${search}`) || ""
        }${isAttachment ? "&attachment=true" : ""}`
      )
        .then((res) => {
          if (!isAttachment)
            dispatch({
              type: GET_LOYALTY_CUSTOMERS,
              payload: res?.data?.payload,
            });

          return resolve(isAttachment ? res?.data : res?.data?.payload);
        })
        .catch((err) => {
          err?.response?.status !== 401 &&
            toastr.error(
              "Error",
              err?.response?.data?.message || "Something went wrong!"
            );
          return reject(err);
        });
    });
  };

export const getLoyaltyActivity =
  (storeId, period, page, start, end, filter, customer_id) => (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.get(
        `/v1/insights/activity/loyalty?filter=${filter}${
          (storeId && `&storeId=${storeId}`) || ""
        }${(customer_id && `&customer_id=${customer_id}`) || ""}${
          (period && `&period=${period}`) || ""
        }${(page && `&page=${page}`) || "1"}${
          (start && `&start=${start}`) || ""
        }${(end && `&end=${end}`) || ""}`
      )
        .then((res) => {
          dispatch({
            type: GET_LOYALTY_ACTIVITY,
            payload: res?.data?.payload,
          });
          return resolve(true);
        })
        .catch((err) => {
          err?.response?.status !== 401 &&
            toastr.error(
              "Error",
              err?.response?.data?.message || "Something went wrong!"
            );
          return reject(err);
        });
    });
  };

export const exportLoyaltyActivityCall = (
  storeId,
  period,
  page,
  start,
  end,
  filter,
  customerName
) => {
  return new Promise((resolve, reject) => {
    Api.get(
      `/v1/insights/activity/loyalty?filter=${filter}${
        (storeId && `&storeId=${storeId}`) || ""
      }${(customerName && `&search=${customerName}`) || ""}${
        (period && `&period=${period}`) || ""
      }${(page && `&page=${page}`) || "1"}${
        (start && `&start=${start}`) || ""
      }${(end && `&end=${end}`) || ""}&attachment=true`
    )
      .then((res) => {
        return resolve(res);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const getBanners = (storeId, loyaltyType) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/loyalty/templates/${storeId}/banners/${loyaltyType}`)
      .then((res) => {
        dispatch({
          type: GET_BANNERS,
          payload: res?.data?.payload,
        });

        return resolve(true);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const getAdvancedCashbackSeedData = (storeId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/loyalty/templates/${storeId}`)
      .then((res) => {
        dispatch({
          type: SET_ADVANCED_CASHBACK_SEED_DATA,
          payload: res?.data?.payload?.templates?.advanced_cashback || [],
        });

        return resolve(res.data.payload?.templates?.advanced_cashback);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const getItemsMenu = (storeId, isDontDispatch) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/loyalty/${storeId}/menu`)
      .then((res) => {
        if (!isDontDispatch)
          dispatch({
            type: SET_ITEMS_MENU,
            payload: res?.data?.payload?.items,
          });

        return resolve(res?.data?.payload?.items);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const toggleLoyaltyActivation = (storeId, data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.patch(`/v1/loyalty/status/${storeId}`, data)
      .then((res) => {
        dispatch({
          type: SET_LOYALTY_DATA,
          payload: res?.data?.payload,
        });
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const getDraftStatus = (storeId) => () => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/loyalty/draft/${storeId}`)
      .then((res) => {
        return resolve(res?.data?.payload?.is_draft);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const getNoOfActiveLoyalties = (groupId) => () => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/groups/${groupId}/active-loyalty-count`)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );
        return reject(err?.response?.data?.message);
      });
  });
};

export const resetLoyalty = () => (dispatch) => {
  dispatch({
    type: RESET_LOYALTY,
    payload: {},
  });
};

const clearLoyaltyCachedCall = async (endpoint) => {
  try {
    const res = await Api.delete(endpoint);
    return res.data.payload;
  } catch (err) {
    return err;
  }
};

export const clearCachedLoyalty = async (
  storeId,
  entityId,
  isAdvCb,
  isLifetimeSpent
) => {
  try {
    await clearLoyaltyCachedCall(`/v1/loyalty/${storeId}`);
    if (isLifetimeSpent)
      await clearLoyaltyCachedCall(`/v1/loyalty/${storeId}/rewards`);
    const endpoint = isAdvCb
      ? `/v1/loyalty/${entityId}/tiers`
      : `/v1/loyalty/${storeId}/rewards`;
    await clearLoyaltyCachedCall(endpoint);
  } catch (err) {
    return err;
  }
};
